module.exports = __webpack_public_path__ + "static/media/img-bot-right.7f67777d.png";